import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay"]

  connect() {
    this.boundHandleKeydown = this.handleKeydown.bind(this)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundHandleKeydown)
    this.restoreScroll()
  }

  open(event) {
    event.preventDefault()

    this.overlayTarget.hidden = false
    document.body.style.overflow = "hidden"
    document.addEventListener("keydown", this.boundHandleKeydown)
    this.overlayTarget.querySelector(".dsub-modal__close")?.focus()
  }

  close(event) {
    event?.preventDefault()

    this.overlayTarget.hidden = true
    document.removeEventListener("keydown", this.boundHandleKeydown)
    this.restoreScroll()
  }

  closeOnBackdrop(event) {
    if (event.target === this.overlayTarget) {
      this.close(event)
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close(event)
    }
  }

  restoreScroll() {
    document.body.style.overflow = ""
  }
}
